import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const ReplyIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5.84675 9L5.84675 9.03355L9.15541 12.3422C9.54781 12.7346 9.54781 13.3708 9.15541 13.7632C8.76302 14.1556 8.12682 14.1556 7.73443 13.7632L2.35354 8.38231C2.15828 8.18705 2.15828 7.87047 2.35354 7.67521L7.73443 2.29433C8.12682 1.90193 8.76302 1.90193 9.15541 2.29433C9.54781 2.68672 9.54781 3.32292 9.15541 3.71531L5.87072 7L13 7C17.9706 7 22 11.0294 22 16L22 21C22 21.5523 21.5523 22 21 22C20.4477 22 20 21.5523 20 21L20 16C20 12.134 16.866 9 13 9L5.84675 9Z"
    fill="currentColor"
  />,
  "ReplyIcon"
);
